
/* @ngInject */
function AssetPreviewTabActivitiesController ($scope, $rootScope, NewAssetService, TemplateService, ToastService, UserService, ArtsService, $translate, RepositoryService) {
  $scope.activities = []
  $scope.showLoadMore = false
  $scope.loading = true
  let currentSkip = 0

  const api = {
    _loadActivity,
    _getActivities,
    _formatDateAndTime,
    _getActivitiesDate,
    _truncateText,
    _getUserProfileImage,
    _getActivityDescriptionForTemplates,
    _getActivityDescriptionForRepositoryAsset,
    _getActivityDescriptionForRepositoryFolder
  }
  this.getApi = () => api

  const requestsByLocation = {
    materials: {
      getData: (templateId, limit, offset) => TemplateService.getTemplateActivity(templateId, limit, offset)
    },
    materialsApproval: {
      getData: (templateId, limit, offset) => TemplateService.getTemplateActivity(templateId, limit, offset)
    },
    repository: {
      getData: (assetId, limit, offset) => NewAssetService.getAssetHistory(assetId, limit, offset)
    },
    workflow: {
      getData: (assetId, limit, offset) => NewAssetService.getAssetHistory(assetId, limit, offset)
    },
    repositoryFolder: {
      getData: (folderId, limit, offset) => RepositoryService.getFolderDetailsById(folderId, limit, offset)
    }
  }

  activate()

  function activate () {}

  $scope.$watchCollection('template', () => {
    $scope.loading = true
    api._loadActivity(10, null, true)
  })

  function _loadActivity (limit, offset, reset) {
    if (reset) {
      $scope.activities = []
      currentSkip = 0
    }

    $scope.showLoadMore = false
    api._getActivities($scope.template.id, limit, offset)
    currentSkip = currentSkip + limit
  }

  $scope.loadMore = () => {
    api._loadActivity(10, currentSkip, false)
  }

  function _getActivities (templateId, limit, offset) {
    const request = requestsByLocation[$scope.location]

    request.getData(templateId, limit, offset)
      .then((activities) => {
        const activityCount = Number(activities.count)
        const mappedActivities = activities.rows.map(activity => {
          let activityText = []

          if ($scope.location === 'repository' || $scope.location === 'workflow') {
            activityText = api._getActivityDescriptionForRepositoryAsset(activity)
          } else if ($scope.location === 'repositoryFolder') {
            activityText = api._getActivityDescriptionForRepositoryFolder(activity)
          } else {
            activityText = api._getActivityDescriptionForTemplates(activity)
          }

          activity.description = api._truncateText(activityText)

          api._getUserProfileImage(activity)
          api._getActivitiesDate(activity)

          return activity
        })

        $scope.activities = $scope.activities.concat(mappedActivities)
        $scope.showLoadMore = $scope.showLoadMore || currentSkip < activityCount
      })
      .catch((err) => {
        console.error(err)
        ToastService.defaultErrorToast()
      })
      .finally(() => {
        $scope.loading = false
      })
  }

  function _getActivitiesDate (activity) {
    activity.date = api._formatDateAndTime(activity.createdAt)
  }

  function _getUserProfileImage (activity) {
    activity.user.profileImage = activity.user.profileImageId ? UserService.getUserProfileImage(activity.user.profileImageId) : null
  }

  function _getActivityDescriptionForTemplates (activity) {
    const operation = activity.operation
    const to = activity.to

    switch (operation) {
      case 'CREATE':
        return $translate.instant('templateActivitiesTab.created')
      case 'RENAME':
        return $translate.instant('templateActivitiesTab.renamed')
      case 'REMOVE':
        return $translate.instant('templateActivitiesTab.archived')
      case 'RESTORE':
        return $translate.instant('templateActivitiesTab.unarchived')
      case 'MOVE_TO':
        return $translate.instant('templateActivitiesTab.moved', { to })
      case 'EDIT':
        return $translate.instant('templateActivitiesTab.edited')
      case 'DUPLICATE':
        return $translate.instant('templateActivitiesTab.duplicated')
      case 'SHARE':
        return $translate.instant('templateActivitiesTab.shared')
      case 'SCHEDULE_PUBLISHING':
        return $translate.instant('templateActivitiesTab.scheduledPublishing')
      case 'UNAVAILABLE_DUE_ASSET_ARCHIVE':
        return $translate.instant('templateActivitiesTab.unavailableDueAssetArchive')
      case 'PUBLISH':
        return $translate.instant('templateActivitiesTab.published')
      case 'CHANGE_STATUS':
        return $translate.instant('templateActivitiesTab.changeStatus', { status: ArtsService.formatApprovalStatusText(to) })
      default:
        return ''
    }
  }

  function _getActivityDescriptionForRepositoryAsset (activity) {
    const operation = activity.operation
    const to = activity.to

    switch (operation) {
      case 'CREATE':
        return $translate.instant('repository.preview.activitiesTab.create')
      case 'RENAME':
        return $translate.instant('repository.preview.activitiesTab.rename', { name: to })
      case 'ORGANIZED':
        return $translate.instant('repository.preview.activitiesTab.organized', { name: to })
      case 'REMOVED':
        return $translate.instant('repository.preview.activitiesTab.removed')
      case 'RESTORE':
        return $translate.instant('repository.preview.activitiesTab.restore')
      case 'COPY_LINK':
        return $translate.instant('repository.preview.activitiesTab.copylink')
      case 'DOWNLOAD':
        return $translate.instant('repository.preview.activitiesTab.download')
      case 'ADDED_ACCESS':
        return $translate.instant('repository.preview.activitiesTab.addedaccess')
      case 'REMOVED_ACCESS':
        return $translate.instant('repository.preview.activitiesTab.removedaccess')
      case 'UPDATE_TAXONOMY':
        return $translate.instant('repository.preview.activitiesTab.updatetaxonomy')
      case 'UPDATED_TAGS':
        return $translate.instant('repository.preview.activitiesTab.updatedtags')
      case 'UPLOAD_NEW_VERSION':
        return $translate.instant('repository.preview.activitiesTab.newversion')
      case 'RESTORE_VERSION':
        return $translate.instant('repository.preview.activitiesTab.restoreversion')

      default:
        return ''
    }
  }

  function _getActivityDescriptionForRepositoryFolder (activity) {
    const operation = activity.operation
    const from = activity.from
    const to = activity.to
    var fromFolderName = activity.fromFolderName
    var toFolderName = activity.toFolderName

    switch (operation) {
      case 'CREATE':
        return $translate.instant('repository.preview.activitiesTabFolder.create')
      case 'RENAME':
        return $translate.instant('repository.preview.activitiesTabFolder.rename', { name: to })
      case 'MOVE':
        return $translate.instant('repository.preview.activitiesTabFolder.movedassettoanotherfolder', { from: fromFolderName, to: toFolderName })
      case 'ADDED_ASSET':
        return $translate.instant('repository.preview.activitiesTabFolder.addedasset', { to: toFolderName })
      case 'MOVED_ASSET':
        return $translate.instant('repository.preview.activitiesTabFolder.movedassettofolder', { from: fromFolderName, to: toFolderName })
      case 'REMOVED_ASSET':
        return $translate.instant('repository.preview.activitiesTabFolder.removedasset', { from })
      case 'RESTORED_ASSET':
        return $translate.instant('repository.preview.activitiesTabFolder.restoredasset', { to })
      case 'COPY_LINK':
        return $translate.instant('repository.preview.activitiesTabFolder.copylink')
      case 'DOWNLOAD':
        return $translate.instant('repository.preview.activitiesTabFolder.download')
      case 'REMOVED':
        return $translate.instant('repository.preview.activitiesTabFolder.removed')
      case 'RESTORE':
        return $translate.instant('repository.preview.activitiesTabFolder.restore')
      case 'ADDED_ACCESS':
        return $translate.instant('repository.preview.activitiesTabFolder.addedaccess', { name: to })
      case 'REMOVED_ACCESS':
        return $translate.instant('repository.preview.activitiesTabFolder.removedaccess', { name: to })

      default:
        return ''
    }
  }

  function _formatDateAndTime (dateISO = new Date()) {
    const configOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }

    const locale = $rootScope.oUser.locale
    const date = new Date(dateISO)
    const hourSeparator = locale === 'PT-BR' ? 'h' : ':'
    const minuteSeparator = locale === 'PT-BR' ? 'min' : ''
    const minutes = date.getMinutes()
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes
    const formattedTime = date.getHours() + hourSeparator + formattedMinutes + minuteSeparator

    return new Intl.DateTimeFormat(locale, configOptions).format(date) + `, ${formattedTime}`
  }

  function _truncateText (text, limit) {
    const lengthLimit = limit || 88

    if (text?.length > lengthLimit) {
      return text.slice(0, lengthLimit) + '...'
    } else {
      return text
    }
  }
}

export { AssetPreviewTabActivitiesController }
